import { computed } from 'vue'
import { useStore } from 'vuex'

const useStoreVuex = () => {
  const mapState = module => {
    const store = useStore()

    try {
      const moduleState = module
        .split('/')
        .reduce(
          (state, currentModulePart) => state[currentModulePart],
          store.state
        )
      return Object.fromEntries(
        Object.keys(moduleState).map(key => [
          key,
          computed(() => moduleState[key])
        ])
      )
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Erro ao recuperar state do módulo ' + module)
      throw error
    }
  }
  const mapGetters = module => {
    const store = useStore()
    try {
      const getters = Object.keys(store.getters).filter(getter =>
        getter.includes(module)
      )
      return Object.fromEntries(
        getters.map(getter => {
          const getterName = getter.replace(module + '/', '')
          return [[getterName], computed(() => store.getters[getter])]
        })
      )
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Erro ao recuperar getters do módulo ' + module)
      throw error
    }
  }
  const mapActions = module => {
    const store = useStore()

    try {
      const actions = Object.keys(store._actions).filter(action =>
        action.includes(module)
      )
      const result = Object.fromEntries(
        actions.map(action => {
          const actionName = action.replace(module + '/', '')
          return [[actionName], value => store.dispatch(action, value)]
        })
      )
      return result
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Erro ao recuperar actions do módulo ' + module)
      throw error
    }
  }

  return { mapState, mapGetters, mapActions }
}

export default useStoreVuex
